const ACCESS_PARAM = 'access'

export const ACCESS_LINK_FRAGMENT = /#access=[^\s"]*/g

let captured: { pathname: string; secret: string } | null = null

export function captureAccessLinkFragment(): void {
  const secret = new URLSearchParams(window.location.hash.slice(1)).get(
    ACCESS_PARAM,
  )
  captured = secret ? { pathname: window.location.pathname, secret } : null
  if (!captured) return
  window.history.replaceState(
    window.history.state,
    '',
    `${window.location.pathname}${window.location.search}`,
  )
}

export function getCapturedAccessLinkSecret(): string | null {
  return captured?.pathname === window.location.pathname
    ? captured.secret
    : null
}

export function redactAccessLinkFragment(value: string): string {
  return value.replace(ACCESS_LINK_FRAGMENT, '#access=[REDACTED]')
}
